module.exports = __webpack_public_path__ + "img/ScienceBook.86cc2194.png";